import { Component, forwardRef, Input, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, DefaultValueAccessor, FormGroupDirective, NG_VALUE_ACCESSOR, CheckboxControlValueAccessor } from '@angular/forms';
import { HappyInputBase } from '../happy-template-input/happy-input-base';


export const CHECKBOX_INPUT_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => HappyCheckboxControlComponent),
    multi: true,
};

@Component({
    selector: 'happy-checkbox-control',
    templateUrl: './happy-checkbox-control.component.html',
    styleUrls: ['./happy-checkbox-control.component.css', '../styles.css'],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    providers: [CHECKBOX_INPUT_VALUE_ACCESSOR]
})
export class HappyCheckboxControlComponent extends HappyInputBase {

    @ViewChild(CheckboxControlValueAccessor) private valueAccessor: CheckboxControlValueAccessor;
    // Override to false by default
    @Input() required = false;

    constructor(parentForm: FormGroupDirective) {
        super(parentForm);
    }

    ngOnInit() {
        this.form = this.parentForm.form;
    }

    writeValue(obj: any) {
        this.valueAccessor.writeValue(obj);
    }

    registerOnChange(fn: any) {
        this.valueAccessor.registerOnChange(fn);
    }

    registerOnTouched(fn: any) {
        this.valueAccessor.registerOnTouched(fn);
    }

    setDisabledState(isDisabled: boolean) {
        this.valueAccessor.setDisabledState(isDisabled);
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/components/happy/happy-checkbox-control/happy-checkbox-control.component.ts